export default __webpack_public_path__ + "static/media/ourteam3.23afe02f.png";